export default {"src":"/intl/_next/static/media/money_bag.13e28efd.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};